export const PUBLISH_SUCCESSFUL = 'VIDEO_PUBLISH/PUBLISH_SUCCESSFUL'
export const SET_PUBLISH_LOADING = 'VIDEO_PUBLISH/SET_PUBLISH_LOADING'
